import React, {useState, Fragment} from "react";
import HelpModal from "../HelpModal";
/* eslint import/no-webpack-loader-syntax: off */
import HelpIcon from "-!svg-react-loader!../../icons/help.svg";

export default function DetailWindowSize({windowHeightNominal, windowWidthNominal}) {
    const [isOpenedModal, setOpenedModal] = useState(false);
    const toggleModal = () => setOpenedModal(isOpenedModal => !isOpenedModal);
    return (
        <Fragment>
            <div className='detail'>
                <div className='field' style={{ whiteSpace: 'nowrap' }}>
                    Window Size
                    <HelpIcon style={{marginLeft: '10px', cursor: 'pointer'}} onClick={toggleModal}></HelpIcon>
                </div>
                <div className='value'>
                    {windowHeightNominal +
                        "cm (h) x " +
                        windowWidthNominal +
                        "cm (w)"}
                </div>
            </div>
            <HelpModal
                type={'Window size'}
                open={isOpenedModal}
                closeHelpModal={toggleModal}
            />
        </Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/cart-item/window-size.js